/* eslint-ignore */
// @ts-nocheck
import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: relative;
  min-height: 100vh;
  height: 100%;
  width: 100%;
  display: flex;
`;

export const StepsMobileContaimer = styled.div`
  height: 100px;
  width: 100%;
  background: #0000ff;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StepsContainer = styled.div`
  width: 410px;
  background: #0000ff;
`;

export const RegistrationContainer = styled.div`
  width: calc(100% - 410px);
  background: linear-gradient( 45deg , #f5f5f5 0%, #f7f7f7 50%, #ececec 100%);

  @media (max-width: 959px) {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }
`;

export const LogoContainer = styled.div`
  margin-top: 48px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
`;

export const Img = styled.img`
  @media (max-width: 959px) {
    width: 26px;
    height: 26px;
    margin-bottom: 4px;
  }
`;

export const StepsItems = styled.div`
  margin-top: 112px;
`;

export const StepNumberContent = styled.div`
  margin-left: 26px;
  width: 32px;
  height: 32px;
  border-radius: 50px;
  border: 2px solid #ffffff;
  font-family: Mangueira;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 25px;
  letter-spacing: 0.01em;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;

  @media (max-width: 959px) {
    margin-left: unset;
  }
`;

export const StepItemWrap = styled.div`
  position: relative;
  font-family: Mangueira;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 25px;
  color: #ffffff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: center;

  & + div {
    margin-top: 24px;
  }

  @media (max-width: 959px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-width: 106px;

    ${StepNumberContent} {
      width: 26px;
      height: 26px;
      font-size: 14px;
    }
  }

  ${({ active }) =>
    active &&
    css`
      font-weight: bold;

      ${StepNumberContent} {
        border: 3px solid #ffffff;

        @media (max-width: 959px) {
          width: 38px;
          height: 38px;
          font-size: 16px;
        }
      }
    `}
`;

export const StepNumber = styled.span`
  @media (max-width: 959px) {
    display: inline-block;
    margin-top: 4px;
  }
`;

export const StepText = styled.div`
  margin-left: 11px;

  @media (max-width: 959px) {
    margin-top: 4px;
    font-size: 10px;
    ${({ active }) =>
      active &&
      css`
        font-size: 14px;
      `}

    @media (max-width: 959px) {
      margin-left: unset;
    }
  }
`;

export const ItemActive = styled.div`
  min-width: 22px;
`;

export const StepsMobileWrap = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  align-content: center;
`;
